<template>
    <page-content>

        <common-table
                ref="table"
                path="web/thirdpart/zhejiang"
                :columns="columns">

            <template slot="search">
                <a-button ghost type="primary" @click="add">新增</a-button>
            </template>

            <template slot="disable" slot-scope="{record}">
                <a-switch :checked="record.disable" size="small" @click="clickDisable(record)"></a-switch>
            </template>

            <template slot="operation" slot-scope="{record}">
                <action-edit @click="edit(record)"></action-edit>
                <action-delete @click="remove(record)"></action-delete>
            </template>

        </common-table>

        <zhe-jiang-edit ref="editDrawer" @success="getList"></zhe-jiang-edit>

    </page-content>

</template>
<script>
    import ZheJiangEdit from './ZheJiangEdit'

    export default {
        components: {
            ZheJiangEdit
        },
        computed: {
            columns() {
                return [
                    {
                        title: '名称',
                        dataIndex: 'name'
                    },
                    {
                        title: '设备MAC',
                        dataIndex: 'mac',
                    },
                    {
                        title: 'SiteId',
                        dataIndex: 'appId'
                    },
                    {
                        title: 'UserId',
                        dataIndex: 'appKey'
                    },
                    {
                        title: '操作',
                        dataIndex: 'operation',
                        width: 80,
                        scopedSlots: {customRender: 'operation'}
                    }
                ]
            }
        },
        methods: {
            add() {
                this.$refs.editDrawer.show()
            },
            edit(record) {
                this.$refs.editDrawer.show(record)
            },
            remove(record) {
                let that = this
                this.$confirm({
                    title: '是否删除该记录?',
                    content: '该操作不可撤销',
                    centered: true,
                    onOk() {
                        that.$delete('web/thirdpart/zhejiang/' + record.id).then(() => {
                            that.$message.success('删除成功')
                            that.getList()
                        })
                    }
                })
            },
            getList() {
                this.$refs.table.getData()
            }

        }
    }
</script>
<style lang="less" scoped>

</style>
